import React from 'react'

function ArrowUpIcon() {
  return (
    <svg
      width="14"
      height="7"
      viewBox="0 0 14 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.292893 6.74372C-0.0976311 6.40201 -0.0976311 5.84799 0.292893 5.50628L6.29289 0.256281C6.68342 -0.0854272 7.31658 -0.0854272 7.70711 0.256281L13.7071 5.50628C14.0976 5.84799 14.0976 6.40201 13.7071 6.74372C13.3166 7.08543 12.6834 7.08543 12.2929 6.74372L7 2.11244L1.70711 6.74372C1.31658 7.08543 0.683417 7.08543 0.292893 6.74372Z"
        fill="black"
        fillOpacity="0.5"
      />
    </svg>
  )
}

export default ArrowUpIcon
